import React from 'react';
export const Select = ({ title, ...rest }) => (
  <svg viewBox="0 0 36 36" {...rest}>
    {title && <title>{title}</title>}
    <path d="M0 9.8c0-.6.3-1.2.6-1.5.9-.9 2.4-.9 3.3 0L18 22.1 32 8c.9-.9 2.4-.9 3.3 0 .9.9.9 2.4 0 3.3L18 28.7.6 11.3C.3 11 0 10.4 0 9.8z" />
  </svg>
);
